import React from "react";
import { inject, observer } from "mobx-react";
import { Button, Spin } from "antd";
import GameListV2 from "../game/gameListV2";
import FilterNav from "../game/filterNav";
import PromptMessage from "./promptMessage";
import Modal from "../modal/modal";
import Language from "../language/language";
import RegistrationNotice from "./registrationNotice";
import PersonInfoNotice from "./personInfoNotice";
import CreateTeamNotice from "./createTeamNotice";
import JoinInTeam from "./joinInTeam";
import SelectRole from "./selectRole";
import SelectBBSTeam from "./selectBBSTeam";

import "./stylesheets/registrationCenter.scss";
import { $const } from "../../helper";

@inject("gameStore", "authStore", "teamStore", "languageStore", "personGameStore")
@observer
export default class RegistrationCenter extends React.Component {
  constructor(props) {
    super();
    props.gameStore.resetNavState(); // 初始渲染的时候重置NavState
    this.state = {
      modalWidth: 457,
      showPersonInfoModal: false,
      isLoading: false,
      lang: props.languageStore.lang
    };
  }

  // 如果切换语言，那么重新初始化本页面
  componentWillReceiveProps(nextProps) {
    if (this.state.lang !== nextProps.languageStore.lang) {
      this.props.gameStore.resetNavState();
      this.initPage.apply(this);

      this.setState({
        lang: nextProps.languageStore.lang
      });
    }
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  componentDidMount() {
    this.initPage.apply(this);
    // 刷新当前用户的战队权限
    this.interval = setInterval(() => {
      this.props.authStore.updateBBSTeamInfo();
    }, 5000);
  }

  async initPage() {
    //尝试获取比赛id
    let paramsArr = this.props.location.search.split("&");
    let _currentId = null;
    paramsArr.forEach(item => {
      if (item.indexOf("id") !== -1) {
        _currentId = item.split("=")[1];
      }
    });
    this.setState({
      isLoading: true
    });

    if (!this.props.authStore.oldUserNeedVaild) {
      // 当老用户个人信息未完善时 不展示数据 一直展示loading界面
      //如果获取到赛事id，那么先获取getV2AllCategory的数据，更正筛选器，更正完了后再请求数据
      if (!Object.is(_currentId, null)) {
        this.props.gameStore.setCurrentGameId(_currentId);

        await Promise.all([
          this.props.gameStore.getUrlSpecificEvent(this.props.gameStore.currentGameId), // 获取URL指定赛事
          this.props.gameStore.getV2AllCategory(),
          this.props.teamStore.getMyTeams(),
          this.props.teamStore.getApplication(),
          this.props.personGameStore.getEvents()
        ]);

        await this.props.gameStore.filterGamesNavObj();

        await this.props.gameStore.filterUrlEventIdGameList(this.props.gameStore.currentGameId); // 根据该指定赛事高亮筛选器，高亮后会自动筛选
        this.setState({
          isLoading: false
        });
      } else {
        // 如果没有获取到赛事id，那么按照正常逻辑来搞
        await Promise.all([
          this.props.gameStore.getGameList(),
          this.props.gameStore.getV2AllCategory(),
          this.props.teamStore.getMyTeams(),
          this.props.teamStore.getApplication(),
          this.props.personGameStore.getEvents()
        ]);

        await this.props.gameStore.filterGamesNavObj();
        this.setState({
          isLoading: false
        });
      }
    }
  }

  closeTerm = () => {
    this.props.gameStore.closeGameTerm();
  };

  closePersonInfoModal = () => {
    this.setState({
      showPersonInfoModal: false
    });
  };

  closeJoinOrCreateModal = () => {
    this.props.authStore.closeJoinOrCreateModal();
  };

  closeUserNoticeModal = () => {
    this.props.authStore.closeUserNotice();
  };

  closeTeamIsLocked = () => {
    this.props.teamStore.closeTeamIsLocked();
  };

  closePersonInfoModal = () => {
    this.props.authStore.closeUserNotice();
  };

  closePersonWorkInfoModal = () => {
    this.props.authStore.closeUserWorkNotice();
  };

  closeSelectRoleModal = () => {
    this.props.teamStore.closeSelctRole();
  };

  refreshWindow = () => {
    window.location.reload();
  };

  renderJoinTeamFail() {
    const lang = this.props.languageStore.lang;
    let msg = this.props.teamStore.errApplicationTeamInfo.msg;
    const status = this.props.teamStore.errApplicationTeamInfo.status;
    if (status === $const.SERVER_CUSTOM_ERROR_CODE.NEED_LOGIN) {
      msg = this.props.languageStore.getResource(lang, "SERVER_ERROR_NEED_LOGIN");
    }
    if (status === $const.SERVER_CUSTOM_ERROR_CODE.VALIDATE_FAILED) {
      msg = this.props.languageStore.getResource(lang, "SERVER_ERROR_VALIDATE_FAILED");
    }

    return (
      <div className="join-team-fail">
        <div className="join-team-fail-msg">{msg}</div>
        <div className="join-team-fail-button-wrapper">
          <Button type="primary" onClick={this.refreshWindow}>
            <Language resource="CONFIRM"></Language>
          </Button>
        </div>
      </div>
    );
  }

  closeSelectBBSTeamModal = () => {
    this.props.teamStore.setSelectBBSTeamModalState(false);
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="registration-center empty">
          <Spin />
        </div>
      );
    }
    return (
      <div className="registration-center" data-perf>
        {this.props.languageStore.lang === "zh" ? <PromptMessage /> : null}
        <FilterNav />
        <GameListV2 games={this.props.gameStore.gameListV2}></GameListV2>
        <Modal
          width={this.state.modalWidth}
          title={
            this.props.gameStore.selectedGame.joinType === "JOIN_A_DELIVERY" ? (
              <Language resource="RECRUITMENT_INSTRUCTIONS" />
            ) : (
              <Language resource="ENTTRY_TEAM" />
            )
          }
          state={this.props.gameStore.showTerm}
          close={this.closeTerm}
        >
          <RegistrationNotice></RegistrationNotice>
        </Modal>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="PERSON_INFO_NOT_COMPLETE" />}
          state={this.props.authStore.userNotice}
          close={this.closePersonInfoModal}
        >
          <PersonInfoNotice state="0" />
        </Modal>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="PERSON_INFO_NOT_COMPLETE" />}
          state={this.props.authStore.userWorkNotice}
          close={this.closePersonWorkInfoModal}
        >
          <PersonInfoNotice state="1" />
        </Modal>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="ENTER_INVITATION" />}
          state={this.props.authStore.joinOrCreateModal}
          close={this.closeJoinOrCreateModal}
        >
          <JoinInTeam />
          {/* 超过时间 后台手动放开的情形 只允许 加入战队 不能创建战队 */}
          {this.props.gameStore.selectedGame.joinType === "JOIN_A_TEAM" ? null : (
            <CreateTeamNotice />
          )}
        </Modal>
        <Modal
          width={885}
          title={<Language resource="JOIN_IN_TEAM" />}
          state={this.props.teamStore.selectRole}
          close={this.closeSelectRoleModal}
        >
          <SelectRole />
        </Modal>
        {/* 请求服务端接口出错后提示 */}
        <Modal state={this.props.teamStore.errApplicationTeamInfo.isJoinTeamFail}>
          {this.renderJoinTeamFail()}
        </Modal>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="TEAM_IS_LOCKED" />}
          state={this.props.teamStore.teamIsLocked}
          close={this.closeTeamIsLocked}
        >
          <div className="team-is-locked">
            {this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.id ? (
              <div className="sub-title">
                {`${this.props.teamStore.joinInTeamInfo &&
                  this.props.teamStore.joinInTeamInfo.college &&
                  this.props.teamStore.joinInTeamInfo.college.name} ${
                  this.props.teamStore.joinInTeamInfo.name
                }`}
                {this.props.teamStore.joinInTeamInfo.teamType === $const.TEAM_TYPE.TEAM ? (
                  <Language resource="TEAM" />
                ) : (
                  <Language resource="CONSORTIUM" />
                )}
                <Language resource="TEAM_LOCK_DESC1" />
                {`${
                  this.props.teamStore.joinInTeamInfo.gevent &&
                  this.props.teamStore.joinInTeamInfo.gevent.titleUuidI18n
                    ? this.props.teamStore.joinInTeamInfo.gevent.titleUuidI18n[
                        this.props.languageStore.lang
                      ]
                    : ""
                }`}
                <Language resource="TEAM_LOCK_DESC2" />
              </div>
            ) : null}
            <div className="operate">
              <Button onClick={this.closeTeamIsLocked}>
                <Language resource="CONFIRM" />
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          width={600}
          title={<Language resource="SELECT_TEAM" />}
          state={this.props.teamStore.selectBBSTeamModalState}
          close={this.closeSelectBBSTeamModal}
        >
          <SelectBBSTeam />
        </Modal>
        <Modal
          width={this.state.modalWidth}
          title={<Language resource="APPLY_NOW" />}
          state={this.props.teamStore.applyTipsBBSState}
          close={() => this.props.teamStore.setApplyTipsBBSState(false)}
        >
          <div className="team-is-locked">
            <div className="sub-title">
              <Language resource="APPLY_TIPS_BBS" />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/registrationCenter.js